"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageOptions = void 0;
/**
 * Options available when sending/publishing a message
 */
const DEFAULT_SQS_VISIBILITY_TIMEOUT_SECONDS = 30;
const MAX_SQS_VISIBILITY_TIMEOUT_SECONDS = 43200;
class MessageOptions {
    static validate(options) {
        if (options.delay && options.visibleAt) {
            throw new Error('MessageOptions: delay and visibleAt cannot be used in conjunction');
        }
        if (options.visibilityTimeout !== undefined) {
            if (options.visibilityTimeout < DEFAULT_SQS_VISIBILITY_TIMEOUT_SECONDS) {
                throw new Error(`MessageOptions: visibilityTimeout cannot be less than the default timeout (${DEFAULT_SQS_VISIBILITY_TIMEOUT_SECONDS}s)`);
            }
            if (options.visibilityTimeout > MAX_SQS_VISIBILITY_TIMEOUT_SECONDS) {
                throw new Error(`MessageOptions: visibilityTimeout cannot be greater than the max timeout (${MAX_SQS_VISIBILITY_TIMEOUT_SECONDS / 60 / 60}hr)`);
            }
        }
    }
}
exports.MessageOptions = MessageOptions;
